var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.86 54.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.32,105.06H109.68c-2.82,0-5.11,2-5.11,4.52v1.5h40.86v-1.5C145.43,107.09,143.14,105.06,140.32,105.06Zm-8.38-3.63.81,5.83h-15.5l.81-5.83h13.88m-.13-3.18h-14a2.61,2.61,0,0,0-2.5,2.18l-1.11,7.95a1.76,1.76,0,0,0,1.79,2.06h18a1.76,1.76,0,0,0,1.79-2.06l-1.06-7.6a3,3,0,0,0-2.91-2.53Zm9.36,17H108.83a3.06,3.06,0,0,0-3.1,3.39l2.79,30.68a3.81,3.81,0,0,0,3.71,3.39h25.54a3.81,3.81,0,0,0,3.71-3.39l2.79-30.68A3.06,3.06,0,0,0,141.17,115.28Zm-23.53,32.26H114.5a2.48,2.48,0,0,1-2.54-2.21l-1.56-22.62a1.83,1.83,0,0,1,1.9-1.87h5.34Zm11.27,0h-7.32v-26.7h7.32Zm7.06,0h-3.22v-26.7h5.17a2,2,0,0,1,2.06,2l-1.56,22.54A2.38,2.38,0,0,1,136,147.54Z",
    transform: "translate(-104.57 -98.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.495d7807.svg";
export { ForwardRef as ReactComponent };